<template>
  <div class="admin-suggestion">
    <page-title title="筛选">
      <el-row :gutter="20" class="admin-suggestion__filter-header">
        <el-col :xl="3" :span="6">
          <span>用户类型：</span>
          <el-select clearable v-model="filter.userType" placeholder="请选择">
            <el-option value="SELLER" label="卖家"></el-option>
            <el-option value="BUYERS" label="买家"></el-option>
            <el-option value="TOURIST" label="游客"></el-option>
          </el-select>
        </el-col>
        <el-col :xl="3" :span="6">
          <span>用户昵称：</span>
          <el-input v-model="filter.name" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="3" :span="6">
          <span>意见类型：</span>
          <el-select clearable v-model="filter.opinionType" placeholder="请选择">
            <el-option v-for="ot in OPINIONTYPE" :value="ot" :label="OPINIONTYPE_ZH[ot]" :key="ot"></el-option>
          </el-select>
        </el-col>
        <el-col :xl="3" :span="6">
          <span>联系方式：</span>
          <el-input v-model="filter.phone" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="3" :span="6">
          <span>处理状态：</span>
          <el-select clearable v-model="filter.state" placeholder="请选择">
            <el-option value="TO_HANDLE" label="未处理"></el-option>
            <el-option value="HANDLED" label="已处理"></el-option>
          </el-select>
        </el-col>
        <el-col :xl="6" :span="9">
          <span>提交时间区间：</span>
          <el-date-picker
            v-model="filterDateRange"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :xl="3" :span="6">
          <el-button @click="getList">查询</el-button>
          <el-button @click="filter = { launchTime: '' };getList()">重置</el-button>
        </el-col>
      </el-row>
    </page-title>
    <page-title title="数据列表">
      <div class="admin-suggestion__body">
        <el-table :data="suggestionData" style="width: 100%" :header-cell-style="{ backgroundColor: `#f7f7f7` }" v-loading="loading">
          <el-table-column type="index" width="90" align="center"> </el-table-column>
          <el-table-column label="用户类型" width="130">
            <template slot-scope="{ row }">
              <template v-if="row.userType === 'SELLER'">
                <i class="el-icon-circle el-icon-s-shop" style="background-color:#005bff"></i>
                <span>卖家</span>
              </template>
              <template v-else-if="row.userType === 'BUYERS'">
                <i class="el-icon-circle el-icon-user-solid" style="background-color:#00bd83"></i>
                <span>买家</span>
              </template>
              <template v-else-if="row.userType === 'TOURIST'">
                <i class="el-icon-circle el-icon-user-solid" style="background-color:#00bd83"></i>
                <span>游客</span>
              </template>
              <template v-else>
                - -
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="userInfo.nickname" label="用户昵称" width="210" :formatter="transferNickname"> </el-table-column>
          <el-table-column prop="opinionType" label="意见类型" width="135" :formatter="transferType"> </el-table-column>
          <el-table-column prop="content" label="意见内容" width="400" show-overflow-tooltip :formatter="transferContent">
          </el-table-column>
          <el-table-column prop="phone" label="联系方式" width="160"></el-table-column>
          <el-table-column label="处理状态" width="160">
            <template slot-scope="{ row }">
              <template v-if="row.state === 'TO_HANDLE'">
                <i class="el-icon-circle el-icon-remove-outline" style="background-color:#C1C4C7"></i>
                <span style="color:#C1C4C7">未处理</span>
              </template>
              <template v-else>
                <i class="el-icon-circle el-icon-circle-check" style="background-color:#005BFF"></i>
                <span style="color:#005BFF">已处理</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="createdDate" label="创建时间" width="215"> </el-table-column>
          <el-table-column label="操作" fixed="right" min-width="70">
            <template slot-scope="{ row }">
              <router-link style="text-decoration:none;color:#005BFF;" :to="`/suggestion/${row.id}`">
                <span>详情</span>
              </router-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <cus-pagination :total="total" :current-page.sync="currentPage" :page-size.sync="pageSize"></cus-pagination>
    </page-title>
  </div>
</template>
<script>
import PageTitle from '@/components/pageTitle.vue';
import CusPagination from '@/components/cusPagination.vue';
import { getFeedbackList } from '@/api/req';
import { OPINIONTYPE, OPINIONTYPE_ZH } from './_eum';

export default {
  name: 'suggestion',
  components: {
    PageTitle,
    CusPagination
  },
  data() {
    return {
      loading: true,
      filter: {
        launchTime: ''
      },
      suggestionData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  computed: {
    filterDateRange: {
      get() {
        return this.filter.launchTime.split(',');
      },
      set(date) {
        this.filter.launchTime = date ? date.join(',') : '';
      }
    },
    OPINIONTYPE: () => OPINIONTYPE,
    OPINIONTYPE_ZH: () => OPINIONTYPE_ZH
  },
  watch: {
    currentPage(page) {
      this.getList();
    }
  },
  methods: {
    getList() {
      this.loading = true;
      const { currentPage: pageNumber, pageSize } = this;
      const req = { pageNumber, pageSize, ...this.filter };
      this.$ajax
        .get(getFeedbackList, req)
        .then(({ data }) => {
          this.loading = false;
          this.total = data.total;
          this.suggestionData = data.rows;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    transferType({ opinionType }) {
      return OPINIONTYPE_ZH[opinionType] || '- -';
    },
    transferNickname({ userInfo: { nickname } }) {
      return nickname || '- -';
    },
    transferContent({ content }) {
      return content || '- -';
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss">
.admin-suggestion {
  &__body {
    margin-bottom: 16px;
    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
    }
    .el-icon-circle {
      margin-right: 8px;
      color: #fff;
      vertical-align: middle;
    }
  }
}
</style>
